module.exports = __webpack_public_path__ + "img/BA 5.51501820.png";